"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5498],{

/***/ 36013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ AuthDecorator; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41248);
/* harmony import */ var _lib_beacon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91435);
/* harmony import */ var _state_auth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30541);
/* harmony import */ var _utils_node__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49503);



/* eslint-disable no-console */ 




var AuthDecorator = function(param) {
    var children = param.children, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {
        return null;
    } : _onClick;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var handleClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var account, response;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,_utils_node__WEBPACK_IMPORTED_MODULE_6__/* .testNodeHealth */ .M)();
                    case 2:
                        _ctx.next = 4;
                        return (0,_lib_beacon__WEBPACK_IMPORTED_MODULE_4__/* .getActiveAccount */ .Fk)();
                    case 4:
                        account = _ctx.sent;
                        if (account) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 8;
                        return (0,_lib_beacon__WEBPACK_IMPORTED_MODULE_4__/* .login */ .x4)();
                    case 8:
                        response = _ctx.sent;
                        dispatch({
                            type: _state_auth__WEBPACK_IMPORTED_MODULE_5__/* .actions.AUTH_LOGIN */ .Nw.AUTH_LOGIN,
                            payload: response
                        });
                    case 10:
                        if (onClick) {
                            onClick();
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var childrenWithProps = react__WEBPACK_IMPORTED_MODULE_2__.Children.map(children, function(child) {
        if (/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.isValidElement)(child)) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(child, {
                onClick: handleClick
            });
        }
        return child;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: childrenWithProps
    });
};


/***/ }),

/***/ 11422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ Avatar; },
  "z": function() { return /* binding */ avatar_Verified; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@versumstudios/ui/dist/index.es.js + 8 modules
var index_es = __webpack_require__(33498);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-avatar/dist/index.module.js
var index_module = __webpack_require__(16235);
// EXTERNAL MODULE: ./src/styles/stitches.ts
var stitches = __webpack_require__(42441);
;// CONCATENATED MODULE: ./src/components/avatar/styles.ts


var Container = (0,stitches/* styled */.zo)("div", {
    position: "relative",
    display: "flex"
});
var StyledRoot = (0,stitches/* styled */.zo)(index_module/* Root */.fC, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    verticalAlign: "middle",
    overflow: "hidden",
    userSelect: "none",
    width: 128,
    height: 128,
    backgroundColor: "$secondaryBackground",
    variants: {
        round: {
            true: {
                borderRadius: 9999
            }
        }
    }
});
var StyledImage = (0,stitches/* styled */.zo)(index_module/* Image */.Ee, {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "inherit"
});
var StyledFallback = (0,stitches/* styled */.zo)(index_module/* Fallback */.NY, {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
var Verified = (0,stitches/* styled */.zo)("div", {
    margin: "0 $space$5",
    fontSize: 14
});
var Path = (0,stitches/* styled */.zo)("path", {});

;// CONCATENATED MODULE: ./src/components/avatar/index.tsx



var Avatar = function(param) {
    var username = param.username, path = param.path, _round = param.round, round = _round === void 0 ? true : _round, size = param.size;
    if (size) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRoot, {
                round: round,
                css: {
                    width: size,
                    height: size
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                        src: path,
                        alt: "".concat(username, " profile")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFallback, {
                        delayMs: path ? 600 : 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Identicon */.bK, {
                            hash: username
                        })
                    })
                ]
            })
        });
    }
    // adjusts to 100% parent
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        css: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRoot, {
            round: round,
            css: {
                width: "100%",
                height: "100%",
                position: "relative",
                backgroundSize: "cover",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
                "&:after": {
                    content: "",
                    display: "block",
                    paddingTop: "calc(1 * 100%);"
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                    src: path,
                    alt: "".concat(username, " profile"),
                    css: {
                        position: "absolute",
                        width: "100%"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFallback, {
                    delayMs: path ? 600 : 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Identicon */.bK, {
                        hash: username
                    })
                })
            ]
        })
    });
};
var avatar_Verified = function(param) {
    var _size = param.size, size = _size === void 0 ? 14 : _size, _secondary = param.secondary, secondary = _secondary === void 0 ? false : _secondary;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Verified, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: size,
            height: size,
            viewBox: "0 0 12 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                    d: "M4.78117 0.743103C5.29164 -0.247701 6.70826 -0.247701 7.21872 0.743103C7.52545 1.33846 8.21742 1.62509 8.8553 1.42099C9.91685 1.08134 10.9186 2.08304 10.5789 3.1446C10.3748 3.78247 10.6614 4.47445 11.2568 4.78117C12.2476 5.29164 12.2476 6.70826 11.2568 7.21872C10.6614 7.52545 10.3748 8.21742 10.5789 8.8553C10.9186 9.91685 9.91685 10.9186 8.8553 10.5789C8.21742 10.3748 7.52545 10.6614 7.21872 11.2568C6.70826 12.2476 5.29164 12.2476 4.78117 11.2568C4.47445 10.6614 3.78247 10.3748 3.1446 10.5789C2.08304 10.9186 1.08134 9.91685 1.42099 8.8553C1.62509 8.21742 1.33846 7.52545 0.743103 7.21872C-0.247701 6.70826 -0.247701 5.29164 0.743103 4.78117C1.33846 4.47445 1.62509 3.78247 1.42099 3.1446C1.08134 2.08304 2.08304 1.08134 3.1446 1.42099C3.78247 1.62509 4.47445 1.33846 4.78117 0.743103Z",
                    css: {
                        fill: secondary ? "$secondaryFill" : "$primaryFill"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.43961 4.23998C8.64623 4.43922 8.65221 4.76823 8.45297 4.97484L5.40604 8.13462L3.54703 6.20676C3.34779 6.00014 3.35377 5.67113 3.56039 5.47189C3.76701 5.27266 4.09602 5.27864 4.29526 5.48525L5.40604 6.63718L7.70475 4.25334C7.90398 4.04672 8.23299 4.04074 8.43961 4.23998Z",
                    css: {
                        fill: "$primaryBackground"
                    }
                })
            ]
        })
    });
// return (
//   <svg width={size} height={size} viewBox="0 0 18 18">
//     <g fill="none" fillRule="evenodd">
//       <path fill="#38D" fillRule="nonzero" d="M9 18A9 9 0 108.999-.001 9 9 0 009 18z" />
//       <path stroke="#FFF" strokeWidth="2" d="M4.13 8.767l3.086 3.087 6.656-6.656" />
//     </g>
//   </svg>
// );
};


/***/ }),

/***/ 64944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y_": function() { return /* reexport */ ActionAuctionsComponent; },
  "JR": function() { return /* reexport */ ActionOffersComponent; },
  "Jw": function() { return /* reexport */ ActionSwapsComponent; },
  "Id": function() { return /* reexport */ DateComponent; },
  "N0": function() { return /* reexport */ LinkComponent; },
  "C9": function() { return /* reexport */ PriceComponent; },
  "av": function() { return /* reexport */ SwapTypeComponent; },
  "Tk": function() { return /* reexport */ TextComponent; },
  "A2": function() { return /* reexport */ UserComponent; }
});

// UNUSED EXPORTS: PreviewComponent, Token, Trending

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
// EXTERNAL MODULE: ./src/components/auth-decorator/index.tsx
var auth_decorator = __webpack_require__(36013);
// EXTERNAL MODULE: ./src/state/modals/index.ts
var modals = __webpack_require__(68525);
// EXTERNAL MODULE: ./src/utils/auctions.ts
var auctions = __webpack_require__(70809);
// EXTERNAL MODULE: ./node_modules/@versumstudios/ui/dist/index.es.js + 8 modules
var index_es = __webpack_require__(33498);
;// CONCATENATED MODULE: ./src/components/table-components/action-auctions.tsx






var ActionAuctionsComponent = function(param) {
    var seller = param.seller, current_bid = param.current_bid, current_bidder = param.current_bidder, auction_id = param.auction_id, end_time = param.end_time;
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var auth = (0,es/* useSelector */.v9)(function(state) {
        return state.auth;
    });
    var viewer = (ref = auth.user) === null || ref === void 0 ? void 0 : ref.id;
    var viewerIsBuyer = viewer === (current_bidder === null || current_bidder === void 0 ? void 0 : current_bidder.user[0].user.id);
    var viewerIsSeller = viewer === seller.user[0].user.id;
    var auctionIsActive = (0,auctions/* isActionActive */.A)({
        end_time: end_time
    });
    var handleCancel = function() {
        dispatch({
            type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
            payload: {
                type: "auction-cancel",
                auctionId: auction_id
            }
        });
    };
    var handleWithdraw = function() {
        dispatch({
            type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
            payload: {
                type: "auction-withdraw",
                auctionId: auction_id
            }
        });
    };
    var handleFinalize = function() {
        dispatch({
            type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
            payload: {
                type: "auction-finalize",
                auctionId: auction_id
            }
        });
    };
    var handleAcceptCurrent = function() {
        dispatch({
            type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
            payload: {
                type: "auction-accept-current",
                auctionId: auction_id
            }
        });
    };
    var handleBid = function() {
        dispatch({
            type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
            payload: {
                type: "auction-bid",
                auctionId: auction_id,
                currentBid: current_bid,
                isMinBid: current_bidder === null
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
        css: {
            "&>*": {
                marginRight: "$space$4"
            }
        },
        children: [
            auctionIsActive && !viewerIsSeller && !viewerIsBuyer && /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_decorator/* AuthDecorator */.X, {
                onClick: handleBid,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                    variant: "market",
                    children: "Bid"
                })
            }),
            auctionIsActive && viewerIsBuyer && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                unset: true,
                css: {
                    color: "$secondaryFill",
                    fontSize: 14
                },
                children: "You are the highest bidder"
            }),
            auctionIsActive && viewerIsSeller && current_bidder === null && /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_decorator/* AuthDecorator */.X, {
                onClick: handleCancel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                    variant: "market",
                    children: "Cancel"
                })
            }),
            auctionIsActive && viewerIsSeller && current_bidder !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_decorator/* AuthDecorator */.X, {
                onClick: handleAcceptCurrent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                    variant: "market",
                    children: "Accept current bid"
                })
            }),
            !auctionIsActive && (viewerIsBuyer || viewerIsSeller) && current_bidder !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_decorator/* AuthDecorator */.X, {
                onClick: handleFinalize,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                    variant: "market",
                    children: "Finalize"
                })
            }),
            !auctionIsActive && viewerIsSeller && current_bidder === null && /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_decorator/* AuthDecorator */.X, {
                onClick: handleWithdraw,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                    variant: "market",
                    children: "Withdraw"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/table-components/action-offers.tsx





var ActionOffersComponent = function(props) {
    var ref;
    var buyer = props.buyer, offer_id = props.offer_id, price = props.price, token = props.token;
    var contract = token.contract, token_id = token.token_id;
    var dispatch = (0,es/* useDispatch */.I0)();
    var auth = (0,es/* useSelector */.v9)(function(state) {
        return state.auth;
    });
    var viewer = (ref = auth.user) === null || ref === void 0 ? void 0 : ref.id;
    var viewerIsBuyer = !!(viewer === buyer.user[0].user.id);
    var viewerIsHolder = !!token.holders.find(function(h) {
        return h.holder_id === viewer;
    });
    var viewerIsCreator = !!token.creators.find(function(c) {
        return c.wallet.user.find(function(e) {
            var ref;
            return e.user.id === ((ref = auth.account) === null || ref === void 0 ? void 0 : ref.address);
        });
    });
    var handleCancelSwap = function() {
        dispatch({
            type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
            payload: {
                type: "offer-cancel",
                offerId: offer_id
            }
        });
    };
    var handleAcceptOffer = function() {
        var ref;
        dispatch({
            type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
            payload: {
                type: "offer-accept",
                id: offer_id,
                price: price,
                platformName: contract.name,
                tokenKT: (ref = contract.wallet) === null || ref === void 0 ? void 0 : ref.address,
                tokenId: token_id
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
        css: {
            "&>*": {
                marginRight: "$space$4"
            }
        },
        children: [
            viewerIsBuyer && /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_decorator/* AuthDecorator */.X, {
                onClick: handleCancelSwap,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                    variant: "market",
                    children: "Cancel offer"
                })
            }),
            (viewerIsHolder || viewerIsCreator) && /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_decorator/* AuthDecorator */.X, {
                onClick: handleAcceptOffer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                    variant: "market",
                    children: "Accept Offer"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(6767);
// EXTERNAL MODULE: ./src/utils/market.tsx
var market = __webpack_require__(93650);
;// CONCATENATED MODULE: ./src/components/table-components/action-swaps.tsx







var ActionSwapsComponent = function(param) {
    var start_price = param.start_price, end_price = param.end_price, current_price = param.current_price, amount = param.amount, amount_left = param.amount_left, seller = param.seller, swap_id = param.swap_id, token = param.token, ending_time = param.ending_time;
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var auth = (0,es/* useSelector */.v9)(function(state) {
        return state.auth;
    });
    var viewer = (ref = auth.user) === null || ref === void 0 ? void 0 : ref.id;
    var viewerIsSeller = viewer === seller.user[0].user.id;
    var isAdvanced = start_price !== end_price;
    var isExpired = (0,market/* didExpire */.t)(ending_time);
    var handleCancelSwap = function() {
        if (isExpired) {
            dispatch({
                type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
                payload: {
                    type: "swap-conclude",
                    swapId: swap_id
                }
            });
        } else {
            dispatch({
                type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
                payload: {
                    type: "swap-cancel",
                    swapId: swap_id
                }
            });
        }
    };
    var handleCollectSwap = function() {
        if (isAdvanced) {
            // slippage modal only 1 quantity
            dispatch({
                type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
                payload: {
                    type: "swap-slippage",
                    swapId: swap_id,
                    startPrice: start_price,
                    endPrice: end_price,
                    amount: amount,
                    amountLeft: amount_left,
                    creatorsTotal: token.creators.length
                }
            });
        } else {
            // collect modal, multiple quantity
            dispatch({
                type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
                payload: {
                    type: "swap-collect",
                    swapId: swap_id,
                    swapPrice: current_price,
                    swapMaxQuantity: amount_left,
                    creatorsTotal: token.creators.length
                }
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
        css: {
            "&>*": {
                marginRight: "$space$4"
            }
        },
        children: viewerIsSeller ? /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_decorator/* AuthDecorator */.X, {
            onClick: handleCancelSwap,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                variant: "market",
                children: isExpired ? "Complete Swap" : "Cancel Swap"
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_decorator/* AuthDecorator */.X, {
            onClick: handleCollectSwap,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Button */.zx, {
                variant: "market",
                children: [
                    "Collect for ".concat((0,format/* MutToTez */.QO)(current_price)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Tezos */.Qo, {})
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/utils/time-ago.ts
var time_ago = __webpack_require__(88080);
;// CONCATENATED MODULE: ./src/components/table-components/date.tsx



var DateComponent = function(param) {
    var timestamp = param.timestamp;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
        css: {
            fontSize: 14,
            color: "$secondaryFill"
        },
        children: time_ago/* timeAgo.format */.S.format(new Date(timestamp))
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/table-components/link.tsx




var LinkComponent = function(param) {
    var url = param.url, label = param.label;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: url,
            locale: router.locale,
            prefetch: false,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                as: "a",
                variant: "basic",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                    children: label
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/table-components/preview.tsx


var PreviewComponent = function(param) {
    var value = param.value;
    return /*#__PURE__*/ _jsx(Box, {
        css: {
            padding: "$space$4",
            img: {
                height: 48,
                width: "auto"
            }
        },
        vertical: true,
        children: /*#__PURE__*/ _jsx("img", {
            src: value,
            alt: "image preview"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/table-components/price.tsx


var PriceComponent = function(param) {
    var value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
        css: {
            fontSize: 14,
            color: "$secondaryFill"
        },
        children: [
            value,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Tezos */.Qo, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/table-components/swap-type.tsx



var SwapTypeComponent = function(param) {
    var start_price = param.start_price, end_price = param.end_price, ending_time = param.ending_time;
    if (ending_time) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
            css: {
                flexDirection: "column"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Text */.xv, {
                unset: true,
                css: {
                    fontSize: 11,
                    color: "$secondaryFill"
                },
                children: [
                    "Time-limited\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Tooltip */.u, {
                        description: "Time-limited swaps automatically end at set date.",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            children: "help"
                        })
                    })
                ]
            })
        });
    }
    if (start_price === end_price) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
            css: {
                flexDirection: "column"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Text */.xv, {
                unset: true,
                css: {
                    fontSize: 11,
                    color: "$secondaryFill"
                },
                children: [
                    "Simple Swap\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Tooltip */.u, {
                        description: "Simple swaps have a fixed price",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            children: "help"
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
        css: {
            flexDirection: "column"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Text */.xv, {
            unset: true,
            css: {
                fontSize: 11,
                color: "$secondaryFill"
            },
            children: [
                "Advanced Swap\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Tooltip */.u, {
                    description: "Advanced swaps have a dynamic price based of a start price and an end price. Start price: ".concat((0,format/* MutToTez */.QO)(start_price), ", End price:  ").concat((0,format/* MutToTez */.QO)(end_price), "."),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        children: "help"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/table-components/text.tsx


var TextComponent = function(param) {
    var value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
        css: {
            fontSize: 14,
            color: "$secondaryFill"
        },
        children: value
    });
};

// EXTERNAL MODULE: ./src/styles/stitches.ts
var stitches = __webpack_require__(42441);
;// CONCATENATED MODULE: ./src/components/table-components/token/styles.ts

var Container = (0,stitches/* styled */.zo)("div", {
    fontFamily: "$mono",
    fontSize: 13,
    display: "flex",
    alignItems: "center",
    img: {
        marginRight: "$space$4"
    },
    span: {
        color: "$secondaryFill",
        fontWeight: 700,
        marginLeft: "$space$5",
        textTransform: "uppercase"
    }
});

;// CONCATENATED MODULE: ./src/components/table-components/token/index.tsx


var Token = function(param) {
    var image = param.image, name = param.name, symbol = param.symbol;
    return /*#__PURE__*/ _jsxs(Styles.Container, {
        children: [
            /*#__PURE__*/ _jsx("img", {
                src: image,
                alt: name,
                width: 20,
                height: 20
            }),
            name,
            /*#__PURE__*/ _jsx("span", {
                children: symbol
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/table-components/trending/styles.ts

var styles_Container = (0,stitches/* styled */.zo)("div", {
    fontFamily: "$mono",
    fontSize: 13,
    display: "flex",
    alignItems: "center",
    i: {
        fontSize: "inherit",
        color: "inherit",
        marginRight: "$space$4"
    }
});

;// CONCATENATED MODULE: ./src/components/table-components/trending/index.tsx


var Trending = function(param) {
    var value = param.value;
    var trendingUp = value > 0;
    var parsedValue = value.toFixed(2);
    return /*#__PURE__*/ _jsxs(Styles.Container, {
        css: {
            color: trendingUp ? "$colors$green" : "$colors$red"
        },
        children: [
            trendingUp ? /*#__PURE__*/ _jsx("i", {
                children: "trending_up"
            }) : /*#__PURE__*/ _jsx("i", {
                children: "trending_down"
            }),
            parsedValue,
            "%"
        ]
    });
};

// EXTERNAL MODULE: ./src/components/avatar/index.tsx + 1 modules
var avatar = __webpack_require__(11422);
// EXTERNAL MODULE: ./src/utils/wallet.ts
var wallet = __webpack_require__(49058);
;// CONCATENATED MODULE: ./src/components/table-components/user.tsx






var UserComponent = function(param) {
    var id = param.id, name = param.name, verified_on_chain = param.verified_on_chain, address = param.address, isYou = param.isYou, isCreator = param.isCreator, parsedScreenName = param.parsedScreenName;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
        css: {
            flexDirection: "column"
        },
        children: [
            name && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/user/".concat(id, "/created"),
                locale: router.locale,
                prefetch: false,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Button */.zx, {
                    as: "a",
                    variant: "basic",
                    css: {
                        display: "flex",
                        fontSize: 14,
                        alignItems: "center"
                    },
                    children: [
                        parsedScreenName,
                        verified_on_chain && /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Verified */.z, {
                            size: 10,
                            secondary: true
                        }),
                        !isYou && isCreator && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Tag */.Vp, {
                            css: {
                                marginLeft: "$space$4"
                            },
                            label: "Creator"
                        }),
                        isYou && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Tag */.Vp, {
                            css: {
                                marginLeft: "$space$4"
                            },
                            label: "You"
                        })
                    ]
                })
            }),
             false && /*#__PURE__*/ 0
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/table-components/index.ts














/***/ }),

/***/ 80125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fk": function() { return /* binding */ getURLFromIPFSorHTTP; },
/* harmony export */   "NB": function() { return /* binding */ Node; },
/* harmony export */   "vR": function() { return /* binding */ getURLFromIPFSURI; }
/* harmony export */ });
/* unused harmony export ensureCIDv1 */
/* harmony import */ var multiformats_cid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81362);
/* eslint-disable no-console */ 
var Node;
(function(Node) {
    Node[Node["INFURA"] = 0] = "INFURA";
    Node[Node["CLOUDFLARE"] = 1] = "CLOUDFLARE";
    Node[Node["PINATA"] = 2] = "PINATA";
    Node[Node["IPFS"] = 3] = "IPFS";
    Node[Node["DWEB"] = 4] = "DWEB";
    Node[Node["VERSUM"] = 5] = "VERSUM";
})(Node || (Node = {}));
var ensureCIDv1 = function(cid) {
    if (cid === "") {
        console.warn("empty cid -----<");
        return "";
    }
    if (!cid.startsWith("baf")) {
        cid = multiformats_cid__WEBPACK_IMPORTED_MODULE_0__/* .CID.parse */ .k.parse(cid).toV1().toString();
    }
    return cid;
};
var getURLFromIPFSURI = function(uri) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Node.IPFS;
    var parts = uri.replace("ipfs://", "").split("/");
    var cid = parts[0];
    var cidv1 = ensureCIDv1(cid);
    var path = parts.length ? "/".concat(parts.slice(1).join("/")) : "";
    switch(type){
        case Node.CLOUDFLARE:
            return "https://cloudflare-ipfs.com/ipfs/".concat(cidv1).concat(path);
        case Node.INFURA:
            return "https://".concat(cidv1, ".ipfs.infura-ipfs.io").concat(path);
        case Node.PINATA:
            return "https://gateway.pinata.cloud/ipfs/".concat(cidv1).concat(path);
        case Node.IPFS:
            return "https://ipfs.io/ipfs/".concat(cidv1).concat(path);
        case Node.DWEB:
            return "https://".concat(cidv1, ".ipfs.dweb.link").concat(path);
        case Node.VERSUM:
            return "https://ipfs.versum.cloud/ipfs/".concat(cidv1).concat(path);
        default:
            return "https://ipfs.io/ipfs/".concat(cidv1).concat(path);
    }
};
// converts ipfs:// if match or returns https://
var getURLFromIPFSorHTTP = function() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", node = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Node.INFURA;
    if (value && value.indexOf("ipfs://") !== -1) {
        return getURLFromIPFSURI(value, node);
    }
    return value;
};


/***/ }),

/***/ 49503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ testNodeHealth; }
/* harmony export */ });
/* unused harmony export testNodes */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);
/* harmony import */ var _lib_beacon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91435);
/* harmony import */ var _state_settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92089);
/* harmony import */ var _state_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80683);


/* eslint-disable @typescript-eslint/no-explicit-any */ 



var testNodes = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var before, result, ref, timestamp, nodes;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    before = Date.now();
                    _ctx.next = 3;
                    return fetch("https://status.versum.xyz/api/rpc");
                case 3:
                    result = _ctx.sent;
                    if (!(result.status === 200)) {
                        _ctx.next = 11;
                        break;
                    }
                    _ctx.next = 7;
                    return result.json();
                case 7:
                    ref = _ctx.sent;
                    timestamp = ref.timestamp;
                    nodes = ref.nodes;
                    return _ctx.abrupt("return", {
                        response: Date.now() - before,
                        timestamp: timestamp,
                        nodes: nodes
                    });
                case 11:
                    return _ctx.abrupt("return", {
                        response: Date.now() - before,
                        timestamp: Date.now(),
                        nodes: []
                    });
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function testNodes() {
        return _ref.apply(this, arguments);
    };
}();
var testNodeHealth = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var callback, store, state, ping, currentNode, curTry, maxTry, swapAndTestNode, healthyNode, _args = arguments;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    callback = _args.length > 0 && _args[0] !== void 0 ? _args[0] : function() {
                        return null;
                    };
                    store = (0,_state_store__WEBPACK_IMPORTED_MODULE_4__/* .getStore */ .bh)();
                    state = store === null || store === void 0 ? void 0 : store.getState();
                    if (!(state.settings.general.nodetype === _constants__WEBPACK_IMPORTED_MODULE_1__/* .NODE_TYPE.AUTO */ .QZ.AUTO)) {
                        _ctx.next = 13;
                        break;
                    }
                    _ctx.next = 6;
                    return testNodes();
                case 6:
                    ping = _ctx.sent;
                    currentNode = ping.nodes.find(function(e) {
                        return "https://".concat(e.node) === state.settings.general.node;
                    });
                    curTry = 0;
                    maxTry = 10;
                    swapAndTestNode = function() {
                        // change to new node
                        (0,_constants__WEBPACK_IMPORTED_MODULE_1__/* .setInitialRandomNode */ .k9)();
                        var nextNode = (0,_constants__WEBPACK_IMPORTED_MODULE_1__/* .getInitialRandomNode */ .hm)().value;
                        // check node from request
                        currentNode = ping.nodes.find(function(e) {
                            return "https://".concat(e.node) === nextNode;
                        });
                        if ((!currentNode || currentNode.level < 0 || currentNode.level > 2) && curTry < maxTry) {
                            curTry += 1;
                            swapAndTestNode();
                        }
                        // if node is valid, save preferences?
                        store === null || store === void 0 ? void 0 : store.dispatch({
                            type: _state_settings__WEBPACK_IMPORTED_MODULE_3__/* .actions.SETTINGS_CHANGE_NODE */ .Nw.SETTINGS_CHANGE_NODE,
                            payload: "https://".concat(currentNode.node)
                        });
                        (0,_lib_beacon__WEBPACK_IMPORTED_MODULE_2__/* .changeBeacon */ .sW)(state.settings.general.network, "https://".concat(currentNode.node));
                    };
                    healthyNode = currentNode.level >= 0 && currentNode.level <= 2;
                    if (!healthyNode) {
                        swapAndTestNode();
                    }
                case 13:
                    callback();
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function testNodeHealth() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 88080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ timeAgo; }
/* harmony export */ });
/* harmony import */ var javascript_time_ago__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19252);
/* harmony import */ var javascript_time_ago_locale_en_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21795);


javascript_time_ago__WEBPACK_IMPORTED_MODULE_0__/* ["default"].addLocale */ .Z.addLocale(javascript_time_ago_locale_en_json__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
var timeAgo = new javascript_time_ago__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z("en-US");


/***/ }),

/***/ 12857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GG": function() { return /* binding */ getScreenName; },
/* harmony export */   "vW": function() { return /* binding */ getUserName; }
/* harmony export */ });
/* unused harmony export sanitiseProfileImage */
/* harmony import */ var _ipfs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80125);
/* harmony import */ var _wallet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49058);
/* eslint-disable no-console */ 

var sanitiseProfileImage = function() {
    var uri = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (uri && uri.indexOf("ipfs://") !== -1) {
        return getURLFromIPFSURI(uri, Node.INFURA);
    }
    // otherwise its already resolved
    return uri;
};
var getUserName = function(id, name) {
    var userName = name === id ? (0,_wallet__WEBPACK_IMPORTED_MODULE_1__/* .preview */ .RN)(id) : "@".concat(name);
    userName = (0,_wallet__WEBPACK_IMPORTED_MODULE_1__/* .preview */ .RN)(id); // eventually remove
    return userName;
};
var getScreenName = function(verified, screenName, id, name) {
    // validate empty screen name before
    var parsedScreenName = screenName;
    // if screen name is null we fill it with the address
    if (!screenName) {
        parsedScreenName = (0,_wallet__WEBPACK_IMPORTED_MODULE_1__/* .preview */ .RN)(id);
    }
    return verified ? parsedScreenName : getUserName(id, name);
};


/***/ })

}]);